var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reportItem",on:{"click":_vm.select}},[_c('div',{staticClass:"reportName"},[_vm._v(_vm._s(_vm.reportName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }